import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";
import Icon from "@/components/Icon";

// DonationButton
const DonationButton = ({ isMobile }: { isMobile: boolean }) => {
  const { t } = useTranslation();
  const router = useRouter();
  const handleClickDonate = () => {
    router.push("#donate-now", undefined, { shallow: true });
  };

  return (
    <div
      className={`fixed top-[44%] z-50 cursor-pointer bg-white shadow-strong ${
        isMobile ? "right-0 rounded-l-md p-2" : "right-4 rounded-2xl px-8 py-7"
      }`}
      onClick={handleClickDonate}
      data-qt="csr_donate_float_click"
    >
      <Icon name="donation" size={isMobile ? 24 : 64} title="donation icon" />
      {!isMobile && <p className="mt-3">{t("csr.love_donation_text")}</p>}
    </div>
  );
};
export default DonationButton;
